module.exports = __webpack_public_path__ + "img/damien-julienne.7c902377.jpg";